import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import closeIcon from '../icons/close-editor.svg'; // Path to your custom icon

import icon from '@ckeditor/ckeditor5-core/theme/icons/cancel.svg';


export default class CloseEditorPlugin extends Plugin {
    init() {
        const editor = this.editor;
        const editorElementId = editor.sourceElement.id; // Retrieve the editor's element ID

        editor.ui.componentFactory.add('closeEditorButton', locale => {
            const view = new ButtonView(locale);

            view.set({
                label: 'Close Editor',
                tooltip: true,
                icon: icon
				// editor.config.get('icons.cancel') // Alternative way to reference bu
            });

            view.on('execute', () => {
                closeEditor(editorElementId); // Pass the editor name to closeEditor
            });

            return view;
        });
    }
}